document.addEventListener('DOMContentLoaded', function () {
  const adLinks = document.querySelectorAll('.inline-advert__link');

  adLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      const adPosition = this.closest('.inline-ad-item')?.dataset.adPosition;
      const destinationUrl = this.href;

      // Google Analytics 4 tracking
      if (typeof gtag !== 'undefined') {
        gtag('event', 'click', {
          event_category: 'Inline Advertisement',
          event_label: destinationUrl,
          custom_parameter_1: adPosition,
          value: 1,
        });
      }

      // Shopify Analytics (if available)
      if (typeof analytics !== 'undefined') {
        analytics.track('Inline Ad Clicked', {
          url: destinationUrl,
          position: adPosition,
          collection: window.location.pathname,
        });
      }

      console.log('Inline ad clicked:', {
        url: destinationUrl,
        position: adPosition,
        timestamp: new Date().toISOString(),
      });
    });
  });
});
